import { useI18n } from '@/i18n/i18n-provider';
import { LogoMark } from '@/components/logo-mark';

/**
 * Where the payment processor redirects a donor after a successful charge —
 * the fixed `successUrl` `GivingModule`'s adapter factory hands dLocal, not
 * tenant-specific (the redirect carries no reliable tenant/donor context to
 * personalize with; the donor already knows which church they gave to).
 */
export function GiveSuccessPage() {
  const { t } = useI18n();

  return (
    <main className="auth-page">
      <div className="auth-card">
        <header className="auth-header">
          <LogoMark />
          <h1 className="auth-title">{t('giving.public.thankYouTitle')}</h1>
          <p className="auth-subtitle">{t('giving.public.thankYouBody')}</p>
        </header>
      </div>
    </main>
  );
}
